import { api } from "../../../axios";

export const createNewTemplate = async (authToken: string) => {
  const response = await api.post(
    "signature/templates",
    {},
    {
      headers: { token: authToken }
    }
  );

  return response.data;
};

export const editTemplate = async (authToken: string, templateId: string) => {
  const response = await api.get(`signature/templates/${templateId}/edit`, {
    headers: { token: authToken }
  });

  return response.data;
};

export const updateTemplate = async (
  authToken: string,
  templateId: string,
  title: string,
  docusealId: number
) => {
  const response = await api.patch(
    `signature/templates/${templateId}`,
    {
      template: { title: title, docuseal_template_id: docusealId }
    },
    {
      headers: { token: authToken }
    }
  );

  return response.data;
};
